import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';

const { colors, spacing } = THEME;

export const previewWidgetStyles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: spacing.xl,
		backgroundColor: colors.background.main,
		boxSizing: 'border-box',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center',
		paddingTop: 24,
	},
	avatarContainer: {
		marginBottom: spacing.lg,
	},
	avatarImage: {
		width: '100%',
		height: '100%',
		borderRadius: '50%',
		objectFit: 'cover',
	},
	name: {
		marginTop: 24,
	},
	namePlaceholder: {
		color: colors.text.light,
		fontStyle: 'italic',
	},
	description: {
		marginTop: 16,
	},
	descriptionPlaceholder: {
		fontStyle: 'italic',
		color: colors.text.light,
	},
	// Conversation starters preview styles
	conversationStartersContainer: {
		marginTop: 32,
	},
});
